var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-header"},[_c('img',{staticClass:"back",attrs:{"src":require("assets/img/common/back.png")},on:{"click":_vm.goBack}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }